import isEmpty from '../../../../utils/isEmpty';
import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import SizeAndCapacitySection from './SizeAndCapacitySection';
import SizeAndCapacitySectionSelection from './SizeAndCapacitySectionSelection';
import { useCapacitySync } from '@features/pdp/hooks/useCapacitySync';
import { useExtraData } from '@features/pdp/hooks';

const SizeAndCapacity = () => {
  const { variants } = useSelector((state: any) => state.pdpItem);
  const extraData = useExtraData();
  const [activeIdx, setActiveIdx] = useState(0);
  const [activeCapacityIdx, setActiveCapacityIdx] = useCapacitySync({ extraData, variants });

  const capacitySectionTitle = extraData?.capacity?.title || 'Size & Capacity';

  let capacity = null;
  if (Array.isArray(extraData?.capacity?.sizes)) {
    capacity = extraData?.capacity?.sizes[activeCapacityIdx];
  } else {
    capacity = extraData?.capacity;
  }

  if (isEmpty(capacity)) return null;

  const sectionSelectors = capacity?.sections.map((s) => {
    return {
      title: s.title,
    };
  });
  const capacitySelectors = extraData?.capacity?.sizes?.map((s) => ({ title: s.value }));
  const handleActiveIdx = (idx: number) => {
    setActiveIdx(idx);
  };
  const handleActiveCapacityIdx = (idx: number) => {
    setActiveCapacityIdx(idx);
  };

  return (
    <div id='Capacity' className='tw-bg-white tw-px-5 tw-py-10 tw-font-bold'>
      <h2 className='tw-mb-10 tw-text-center tw-text-2xl tw-text-brand-black'>{capacitySectionTitle}</h2>

      <div>
        {capacity?.sections.map((section, idx) => (
          <SizeAndCapacitySection key={idx} section={section} isActive={activeIdx === idx} />
        ))}

        {sectionSelectors && sectionSelectors.length > 1 && (
          <SizeAndCapacitySectionSelection
            textOnly={extraData?.capacity?.textOnly}
            selectors={sectionSelectors}
            activeIdx={activeIdx}
            setActiveIdx={handleActiveIdx}
          />
        )}

        {capacitySelectors && capacitySelectors.length > 1 && (
          <SizeAndCapacitySectionSelection
            textOnly
            selectors={capacitySelectors}
            activeIdx={activeCapacityIdx}
            setActiveIdx={handleActiveCapacityIdx}
          />
        )}
      </div>
    </div>
  );
};

export default memo(SizeAndCapacity);
